module.exports = __webpack_public_path__ + "img/horizontal_3_7_5.89f2bd9c.png";